export default __webpack_public_path__ + "static/media/treasure11.fcfe5f2d.png";